import { render, staticRenderFns } from "./ServiceTag.vue?vue&type=template&id=2c5f83c6&"
import script from "./ServiceTag.vue?vue&type=script&lang=js&"
export * from "./ServiceTag.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTag.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports